'use client';

import { useMemo } from 'react';

export function useEnvironment() {
  const isDev = useMemo(() => {
    return process.env.NEXT_PUBLIC_IS_DEV === 'true';
  }, []);

  return { isDev };
}
